const getHashFromPath = (path: string) => {
  const hashSignIndex = path.lastIndexOf('#');
  if (hashSignIndex < 0) return '';
  return path.slice(hashSignIndex);
};

export default getHashFromPath;
